
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/HousingPrivileges",
      function () {
        return require("private-next-pages/HousingPrivileges/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/HousingPrivileges"])
      });
    }
  